import {enableProdMode, provideZoneChangeDetection} from '@angular/core';
import {platformBrowser} from '@angular/platform-browser';

import interact from 'interactjs';
import {AppModule} from './app';
import {UserService} from 'auth-module/services/user.service';
import {XsrfTokenReader} from 'auth-module/services/xsrf-token-reader.service';
import {environment} from './environments/environment';

declare let jQuery: any;

if (environment.production) {
  enableProdMode();
}

// Still can't get jQuery to use typings properly.
(function ($) {
  const observer = new MutationObserver(function () {
    const modal = $('.trumbowyg-modal');
    if (modal.length > 0) {
      const top = modal.position().top;
      const clientHeight = document.body.clientHeight;
      const height = modal.height();

      if ((top + height) > clientHeight) {
        modal.css('top', (clientHeight - height) + 'px');
      }
    }
  });
  observer.observe(document, {attributes: false, childList: true, characterData: false, subtree: true});

  // Use our own icons (or, rather, Google Material Icons).
  $.trumbowyg.svgPath = 'assets/icons.svg';
  $.extend(true, $.trumbowyg, {
    langs: {
      // jshint camelcase:false
      it: {
        foreColor: 'Colore testo',
        backColor: 'Colore sfondo',
        italic: 'Corsivo'
      },
      da: {
        foreColor: 'Tekstfarve',
        backColor: 'Baggrundsfarve',
        formatting: 'Formatering',
        removeformat:"Ryd formatering"
      }
    }
  });
})(jQuery);

// Fix tap and hold on Android.
interact.pointerMoveTolerance(5);
interact.dynamicDrop(true);

platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], }).then(ref => {
  (($: any) => {
    $.ajaxPrefilter((options: any) => {
      const userService = ref.injector.get(UserService);

      if(options.url.includes('{pmDomain}')) {
        options.url = options.url.replace('{pmDomain}', userService.domain);
      }

      const xsrfTokenReader = ref.injector.get(XsrfTokenReader);
      const token = xsrfTokenReader.getToken(userService.domain);

      if (options.method === 'GET' || options.method === 'HEAD' || !token) {
        return;
      }

      options.beforeSend = function (xhr: any) {
        xhr.setRequestHeader('X-XSRF-TOKEN', token);
      }
    })
  })(jQuery);
});
